export const actionPermissions = [
  "chat.threads.acknowledgeMessages",
  "chat.threads.myFeed",
  "chat.threads.post",
  "chat.threads.retrieve",
  "chat.threads.subscribe",
  "chat.threads.unsubscribe",
  "crm.chains.list",
  "crm.chains.nameChain",
  "crm.checklistTemplate.list",
  "crm.checklistTemplate.retrieve",
  "crm.checklistTemplate.save",
  "crm.contactList.removeContact",
  "crm.contactList.retrieve",
  "crm.contactList.saveContact",
  "crm.customerTags.create",
  "crm.customerTags.list",
  "crm.customers.allCustomers",
  "crm.customers.assignToChain",
  "crm.customers.bulkRegisterFromCsv",
  "crm.customers.bulkRetrieve",
  "crm.customers.changeStatus",
  "crm.customers.designateVisitLocation",
  "crm.customers.reassignRegion",
  "crm.customers.registerCustomer",
  "crm.customers.renameCustomer",
  "crm.customers.retrieve",
  "crm.customers.tagCustomer",
  "crm.customers.untagCustomer",
  "crm.fixedRoutes.list",
  "crm.groups.assignGroups",
  "crm.groups.list",
  "crm.groups.myGroups",
  "crm.groups.retrieve",
  "crm.macroregions.list",
  "crm.macroregions.nameMacroregion",
  "crm.myWorkDays.changeBreak",
  "crm.myWorkDays.changeEnd",
  "crm.myWorkDays.changeEvent",
  "crm.myWorkDays.changeStart",
  "crm.myWorkDays.removeBreak",
  "crm.myWorkDays.removeEvent",
  "crm.myWorkDays.retrieve",
  "crm.regions.appendMacroregion",
  "crm.regions.list",
  "crm.regions.nameRegion",
  "crm.regions.retrieve",
  "crm.salespeople.designateHome",
  "crm.salespeople.list",
  "crm.salespeople.register",
  "crm.salespeople.retrieve",
  "crm.salespeople.setManager",
  "crm.salespeople.setWorkStartTime",
  "crm.salespeople.updateRegion",
  "crm.tradeRoutes.archiveTradeRoute",
  "crm.tradeRoutes.getTradeRoutesCount",
  "crm.tradeRoutes.list",
  "crm.tradeRoutes.recalculateDistances",
  "crm.tradeRoutes.renameTradeRoute",
  "crm.tradeRoutes.retrieve",
  "crm.tradeRoutes.retrieve",
  "crm.tradeRoutes.saveAndScheduleTradeRoute",
  "crm.tradeRoutes.saveRouteAsPermanent",
  "crm.tradeRoutes.scheduleTradeRoute",
  "crm.visitChecklist.retrieve",
  "crm.visitChecklist.toggleTask",
  "crm.visitScheduleDays.changeVisitDuration",
  "crm.visitScheduleDays.descheduleVisit",
  "crm.visitScheduleDays.loadFixedRoute",
  "crm.visitScheduleDays.retrieve",
  "crm.visitScheduleDays.scheduleVisit",
  "crm.visits.cancelVisit",
  "crm.visits.changeEndTime",
  "crm.visits.changeStartTime",
  "crm.visits.customerRecentVisits",
  "crm.visits.end",
  "crm.visits.myDay",
  "crm.visits.myUnfinishedVisits",
  "crm.visits.plan",
  "crm.visits.refreshScheduleDay",
  "crm.visits.retrieve",
  "crm.visits.start",
  "crm.visits.userDay",
  "crm.workDays.milageReport",
  "crm.workDays.refreshVisit",
  "crm.workDays.retrieve",
  "crm.workDays.workTimeReport",
  "discussion.orderComments.commentList",
  "discussion.orderComments.post",
  "discussion.priceListProposalComments.commentList",
  "discussion.priceListProposalComments.post",
  "ediConnector.orders.documentErrors",
  "ediConnector.orders.maintenance.syncComarchRelation",
  "ediConnector.orders.maintenance.syncInfiniteDocuments",
  "ediConnector.orders.retrieve",
  "ediConnector.orders.retry",
  "ediConnector.orders.skip",
  "feed.myNotifications.dismiss",
  "feed.myNotifications.list",
  "feed.notifications.refresh",
  "feed.tasks.maintenance.reset",
  "feed.tasks.myTasks",
  "iam.authorization.allUserPermissions",
  "iam.authorization.isUserAllowed",
  "iam.authorization.isUserAllowedEach",
  "iam.authorization.userDirectories",
  "iam.groups.create",
  "iam.groups.list",
  "iam.groups.retrieve",
  "iam.groups.update",
  "iam.me.isAllowed",
  "iam.me.isAllowedEach",
  "iam.me.updateProfile",
  "iam.me.user",
  "iam.permissions.accessibleServices",
  "iam.permissions.authorizedUsers",
  "iam.permissions.list",
  "iam.profiles.all",
  "iam.profiles.retrieve",
  "iam.roles.create",
  "iam.roles.list",
  "iam.roles.retrieve",
  "iam.roles.update",
  "iam.users.create",
  "iam.users.currentUser",
  "iam.users.delete",
  "iam.users.list",
  "iam.users.restore",
  "iam.users.retrieve",
  "iam.users.update",
  "invoices.budgets.addManager",
  "invoices.budgets.create",
  "invoices.budgets.list",
  "invoices.budgets.removeManager",
  "invoices.budgets.retrieve",
  "invoices.budgets.update",
  "invoices.budgets.updateAlert",
  "invoices.customers.appendCustomerToInvoice",
  "invoices.customers.listByCustomer",
  "invoices.customers.listByInvoice",
  "invoices.customers.removeAssociation",
  "invoices.invoiceThreads.addComment",
  "invoices.invoiceThreads.allThreads",
  "invoices.invoiceThreads.approve",
  "invoices.invoiceThreads.attachFile",
  "invoices.invoiceThreads.close",
  "invoices.invoiceThreads.correctInvoice",
  "invoices.invoiceThreads.create",
  "invoices.invoiceThreads.inviteParticipant",
  "invoices.invoiceThreads.invoiceIssuerAutocomplete",
  "invoices.invoiceThreads.maintenance.rebuildIndices",
  "invoices.invoiceThreads.myThreads",
  "invoices.invoiceThreads.removeAttachment",
  "invoices.invoiceThreads.reopen",
  "invoices.invoiceThreads.retractBudgetSignature",
  "invoices.invoiceThreads.retractValiditySignature",
  "invoices.invoiceThreads.retrieve",
  "invoices.invoiceThreads.revokeApproval",
  "invoices.invoiceThreads.setAccountingStatus",
  "invoices.invoiceThreads.setAcknowledgement",
  "invoices.invoiceThreads.setReceptionStatus",
  "invoices.invoiceThreads.signBudget",
  "invoices.invoiceThreads.signValidity",
  "invoices.invoiceThreads.similarThreads",
  "invoices.invoiceThreads.titleAutocomplete",
  "pickList.groupings.all",
  "pickList.groupings.assignItem",
  "pickList.groupings.modify",
  "pickList.groupings.removeItem",
  "pickList.pickLists.preview",
  "priceReport.reports.create",
  "priceReport.reports.customerReports",
  "priceReport.reports.maintenance.rebuild",
  "priceReport.reports.myPastReports",
  "priceReport.subjects.all",
  "priceReport.subjects.search",
  "priceReport.subjects.update",
  "pricing.payers.approveProposal",
  "pricing.payers.getEventNotifications",
  "pricing.payers.proposeRuleChange",
  "pricing.payers.rejectProposal",
  "pricing.payers.retractProposal",
  "pricing.payers.retrieve",
  "pricing.priceLists.approveProposal",
  "pricing.priceLists.create",
  "pricing.priceLists.list",
  "pricing.priceLists.maintenance.rebuildIndices",
  "pricing.priceLists.priceListItemDetail",
  "pricing.priceLists.priceListProposals",
  "pricing.priceLists.proposeChanges",
  "pricing.priceLists.rejectProposal",
  "pricing.priceLists.rename",
  "pricing.priceLists.retractProposal",
  "pricing.priceLists.retrieve",
  "pricing.priceLists.upcomingChanges",
  "pricing.pricedItems.maintenance.rebuild",
  "pricing.pricedItems.search",
  "pricing.tradeItems.list",
  "pricing.tradeItems.register",
  "pricing.tradeItems.retrieve",
  "pricing.tradeItems.revise",
  "profitMargin.costTable.retrieve",
  "profitMargin.costTable.update",
  "profitMargin.discountTable.currentDiscountRate",
  "profitMargin.discountTable.retrieve",
  "profitMargin.discountTable.update",
  "profitMargin.orders.adjustMargin",
  "profitMargin.orders.maintenance.loadPastOrders",
  "profitMargin.orders.maintenance.rebuildOrderChanges",
  "profitMargin.orders.marginsByOrder",
  "profitMargin.orders.preview",
  "profitMargin.orders.regionMargins",
  "profitMargin.targetTable.retrieve",
  "profitMargin.targetTable.update",
  "sales.myOrders.list",
  "sales.myOrders.retrieve",
  "sales.orderDrafts.addLine",
  "sales.orderDrafts.discard",
  "sales.orderDrafts.list",
  "sales.orderDrafts.maintenance.rebuildIndices",
  "sales.orderDrafts.place",
  "sales.orderDrafts.removeLine",
  "sales.orderDrafts.retrieve",
  "sales.orderDrafts.startDraft",
  "sales.orderDrafts.updateCustomers",
  "sales.orderDrafts.updateLine",
  "sales.orders.addCustomLineDiscount",
  "sales.orders.addCustomOrderDiscount",
  "sales.orders.addLine",
  "sales.orders.changeBaseDiscountRate",
  "sales.orders.changeDeliveryAddress",
  "sales.orders.changeLineQuantity",
  "sales.orders.correctLineBasePrice",
  "sales.orders.customerRecentOrders",
  "sales.orders.list",
  "sales.orders.listByUuids",
  "sales.orders.maintenance.rebuildIndices",
  "sales.orders.maintenance.refreshDelivery",
  "sales.orders.productionSchedule",
  "sales.orders.reassignCustomers",
  "sales.orders.receive",
  "sales.orders.removeCustomLineDiscount",
  "sales.orders.removeCustomOrderDiscount",
  "sales.orders.removeLine",
  "sales.orders.retrieve",
  "sales.orders.setLinePromoPrice",
  "sales.p88Customers.list",
  "sales.p88Customers.maintenance.refreshList",
  "sales.p88Orders.connectionStatus",
  "sales.p88Orders.issue",
  "sales.p88Orders.list",
  "sales.p88Orders.synchronize",
  "sales.p88TradeItems.remove",
  "sales.p88TradeItems.retrieve",
  "sales.p88TradeItems.save",
  "sales.packSizeDefaults.retrieve",
  "sales.packSizeDefaults.setSize",
  "sales.packSizeDefaults.setSizes",
  "search.customers.list",
  "search.customers.maintenance.rebuild",
  "search.customers.maintenance.refresh",
  "search.customers.nearbyCustomers",
  "search.documents.maintenance.refreshAllUsers",
  "search.documents.maintenance.refreshUser",
  "search.documents.maintenance.resetAll",
  "search.documents.search",
  "search.documents.suggest",
  "shipping.orders.assignForeignOrderNumber",
  "shipping.orders.cancelDelivery",
  "shipping.orders.fastestDeliveryDate",
  "shipping.orders.notifications",
  "shipping.orders.rescheduleDelivery",
  "shipping.orders.retrieve",
  "shipping.orders.setDeliveryDeadline",
  "shipping.orders.setPreferredDeliveryDate",
  "shipping.orders.suspendDelivery"
] as const;
